<template>
  <div
    class="region-selector selector"
    :class="{ missing: !classified.region && (regionFocused || showWarnings) }"
  >
    <label for="region"><strong>Région</strong></label>
    <select
      name="region"
      id="region"
      v-model="region"
      @blur="regionFocused = true"
    >
      <option value=""></option>
      <option
        :value="region.term_id"
        v-for="(region, idx) in getSettings.regions"
        v-bind:key="idx"
      >
        {{ region.name }}
      </option>
    </select>
    <div class="required" :if="!classified.region">Champ non renseigné</div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "region-selector",
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regionFocused: false,
    };
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getSettings"]),
    region: {
      get() {
        return this.classified.region;
      },
      set(region) {
        this.$store.commit("setRegion", region);
      },
    },
  },
};
</script>
